import { styled } from "@mui/system";
import { ToggleButtonGroup } from "@mui/material";

export const ButtonGroup = styled(ToggleButtonGroup)(() => ({
    height: "23px",
    justifyContent: "center",
    "@media (max-width: 850px)": {
        width: "100%"
    }
}))